var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "インポート",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c("div", [
            _c("div", { staticStyle: { width: "1200px" } }, [
              _vm.master_name == "item"
                ? _c("span", [
                    _c("div", { staticClass: "form-inline" }, [
                      _vm._v("\n            1.発注先を選択\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-inline" },
                      [
                        _c(
                          "b-form-select",
                          {
                            staticStyle: {
                              width: "200px",
                              "margin-left": "10px",
                            },
                            on: { change: _vm.SelHattyuCompany },
                            model: {
                              value: _vm.hattyu_company_sel,
                              callback: function ($$v) {
                                _vm.hattyu_company_sel = $$v
                              },
                              expression: "hattyu_company_sel",
                            },
                          },
                          _vm._l(_vm.hattyu_company_list, function (option) {
                            return _c(
                              "option",
                              {
                                key: option.id,
                                domProps: { value: option.value },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(option.text) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.master_name != "item"
                ? _c("div", { staticClass: "form-inline" }, [
                    _vm._v(
                      "\n          1.CSVファイルを選択\n             ※ファイルの種類(エンコード)は「UTF-8」にして下さい\n        "
                    ),
                  ])
                : _c("div", { staticClass: "form-inline" }, [
                    _vm._v(
                      "\n          2.CSVファイルを選択\n             ※ファイルの種類(エンコード)は「UTF-8」にして下さい\n        "
                    ),
                  ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-left": "20px" } },
                [
                  _c("b-form-file", {
                    staticStyle: {
                      width: "500px",
                      "text-align": "left !important",
                      float: "left !important",
                    },
                    attrs: {
                      state: Boolean(_vm.csv_file),
                      accept: "text/csv",
                      placeholder: "Choose a file or drop it here...",
                    },
                    on: { change: _vm.upload_csv_file },
                    model: {
                      value: _vm.csv_file,
                      callback: function ($$v) {
                        _vm.csv_file = $$v
                      },
                      expression: "csv_file",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.master_name != "item"
                ? _c("div", { staticClass: "form-inline" }, [
                    _vm._v("\n          2.ヘッダーを設定\n        "),
                  ])
                : _c("div", { staticClass: "form-inline" }, [
                    _vm._v("\n          3.ヘッダーを設定\n        "),
                  ]),
              _vm._v(" "),
              _vm.master_name != "item"
                ? _c("div", { staticClass: "form-inline" }, [
                    _c(
                      "table",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { id: "header_tbl" },
                      },
                      [
                        _c("tr", [
                          _vm.master_name == "hattyu_company"
                            ? _c("th", [_vm._v("発注コード")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.master_name == "hattyu_company"
                            ? _c("th", [_vm._v("発注先")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.master_name == "hattyu_company"
                            ? _c("th", [_vm._v("発注先(ひらがな)")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.master_name == "client_company"
                            ? _c("th", [_vm._v("顧客コード")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.master_name == "client_company"
                            ? _c("th", [_vm._v("顧客名")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.master_name == "client_company"
                            ? _c("th", [_vm._v("顧客名(ひらがな)")])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("th", [_vm._v("郵便番号")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("住所1")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("住所2")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("住所3")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tr",
                          _vm._l(7, function (n) {
                            return _c(
                              "td",
                              { key: n },
                              [
                                _c(
                                  "b-form-select",
                                  {
                                    staticStyle: { width: "140px" },
                                    model: {
                                      value: _vm.header_sel[n - 1],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.header_sel, n - 1, $$v)
                                      },
                                      expression: "header_sel[n - 1]",
                                    },
                                  },
                                  [
                                    _c("option"),
                                    _vm._v(" "),
                                    _vm._l(_vm.header_list, function (option) {
                                      return _c(
                                        "option",
                                        {
                                          key: option.id,
                                          domProps: { value: option.value },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(option.text) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _c("div", { staticClass: "form-inline" }, [
                    _c(
                      "table",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { id: "header_tbl" },
                      },
                      [
                        _c("tr", [
                          _c("th", [_vm._v("商品コード")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("商品分類")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("商品名")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("仕入れ単価")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("単価")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("税率")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("メーカー")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tr",
                          _vm._l(7, function (n) {
                            return _c(
                              "td",
                              { key: n },
                              [
                                n == 6
                                  ? _c(
                                      "b-form-select",
                                      {
                                        staticStyle: { width: "140px" },
                                        model: {
                                          value: _vm.header_sel[n - 1],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.header_sel, n - 1, $$v)
                                          },
                                          expression: "header_sel[n - 1]",
                                        },
                                      },
                                      [
                                        _c("option"),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.header_list,
                                          function (option) {
                                            return _c(
                                              "option",
                                              {
                                                key: option.id,
                                                domProps: {
                                                  value: option.value,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(option.text) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                n == 6
                                  ? _c(
                                      "b-form-select",
                                      {
                                        staticStyle: { width: "80px" },
                                        model: {
                                          value: _vm.tax_type,
                                          callback: function ($$v) {
                                            _vm.tax_type = $$v
                                          },
                                          expression: "tax_type",
                                        },
                                      },
                                      _vm._l(
                                        _vm.tax_type_list,
                                        function (option2) {
                                          return _c(
                                            "option",
                                            {
                                              key: option2.id,
                                              domProps: {
                                                value: option2.value,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(option2.text) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c(
                                      "b-form-select",
                                      {
                                        staticStyle: { width: "140px" },
                                        model: {
                                          value: _vm.header_sel[n - 1],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.header_sel, n - 1, $$v)
                                          },
                                          expression: "header_sel[n - 1]",
                                        },
                                      },
                                      [
                                        _c("option"),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.header_list,
                                          function (option) {
                                            return _c(
                                              "option",
                                              {
                                                key: option.id,
                                                domProps: {
                                                  value: option.value,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(option.text) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
              _vm._v(" "),
              _vm.master_name != "item"
                ? _c(
                    "div",
                    { staticClass: "form-inline" },
                    [
                      _c("div", { staticStyle: { "margin-left": "640px" } }, [
                        _vm._v(
                          "\n            既に同じidがある場合は上書き保存、無い場合は新規登録されます。\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.import_flg
                        ? _c(
                            "b-button",
                            {
                              staticStyle: {
                                "margin-left": "935px",
                                width: "150px !important",
                              },
                              attrs: { variant: "primary" },
                              on: { click: _vm.csvImport },
                            },
                            [
                              _c("b-icon", { attrs: { icon: "save" } }),
                              _vm._v(" インポート\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.import_flg
                        ? _c(
                            "b-button",
                            {
                              staticStyle: {
                                "margin-left": "935px",
                                width: "150px !important",
                              },
                              attrs: { variant: "primary", disabled: "" },
                            },
                            [
                              _c("b-spinner", { attrs: { small: "" } }),
                              _vm._v("\n            Loading...\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "form-inline" },
                    [
                      _c("div", { staticStyle: { "margin-left": "640px" } }, [
                        _vm._v(
                          "\n            既に同じ商品コードがある場合は上書き保存、無い場合は新規登録されます。\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.import_flg
                        ? _c(
                            "b-button",
                            {
                              staticStyle: {
                                "margin-left": "995px",
                                width: "150px !important",
                              },
                              attrs: { variant: "primary" },
                              on: { click: _vm.csvImport },
                            },
                            [
                              _c("b-icon", { attrs: { icon: "save" } }),
                              _vm._v(" インポート\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.import_flg
                        ? _c(
                            "b-button",
                            {
                              staticStyle: {
                                "margin-left": "995px",
                                width: "150px !important",
                              },
                              attrs: { variant: "primary", disabled: "" },
                            },
                            [
                              _c("b-spinner", { attrs: { small: "" } }),
                              _vm._v("\n            Loading...\n          "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }